package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.MacosSimpleIcons: ImageVector
    get() {
        if (_macosSimpleIcons != null) {
            return _macosSimpleIcons!!
        }
        _macosSimpleIcons = Builder(name = "MacosSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(0.0f, 14.73f)
                horizontalLineToRelative(0.94f)
                verticalLineToRelative(-2.45f)
                curveToRelative(0.0f, -0.48f, 0.32f, -0.84f, 0.77f, -0.84f)
                curveToRelative(0.44f, 0.0f, 0.71f, 0.28f, 0.71f, 0.72f)
                verticalLineToRelative(2.57f)
                horizontalLineToRelative(0.92f)
                lineTo(3.34f, 12.25f)
                curveToRelative(0.0f, -0.48f, 0.31f, -0.81f, 0.76f, -0.81f)
                curveToRelative(0.46f, 0.0f, 0.72f, 0.28f, 0.72f, 0.77f)
                verticalLineToRelative(2.52f)
                horizontalLineToRelative(0.94f)
                verticalLineToRelative(-2.75f)
                curveToRelative(0.0f, -0.80f, -0.52f, -1.33f, -1.31f, -1.33f)
                curveToRelative(-0.58f, 0.0f, -1.05f, 0.31f, -1.25f, 0.81f)
                horizontalLineToRelative(-0.02f)
                curveToRelative(-0.15f, -0.51f, -0.55f, -0.81f, -1.12f, -0.81f)
                curveToRelative(-0.55f, 0.0f, -0.97f, 0.31f, -1.14f, 0.77f)
                lineTo(0.90f, 11.42f)
                verticalLineToRelative(-0.70f)
                lineTo(0.0f, 10.72f)
                verticalLineToRelative(4.01f)
                close()
                moveTo(7.82f, 14.08f)
                curveToRelative(-0.41f, 0.0f, -0.68f, -0.21f, -0.68f, -0.54f)
                curveToRelative(0.0f, -0.32f, 0.26f, -0.52f, 0.71f, -0.55f)
                lineToRelative(0.93f, -0.06f)
                verticalLineToRelative(0.31f)
                curveToRelative(0.0f, 0.48f, -0.43f, 0.84f, -0.96f, 0.84f)
                close()
                moveTo(7.54f, 14.79f)
                curveToRelative(0.51f, 0.0f, 1.02f, -0.27f, 1.25f, -0.70f)
                horizontalLineToRelative(0.02f)
                verticalLineToRelative(0.64f)
                horizontalLineToRelative(0.91f)
                verticalLineToRelative(-2.76f)
                curveToRelative(0.0f, -0.80f, -0.65f, -1.33f, -1.64f, -1.33f)
                curveToRelative(-1.02f, 0.0f, -1.66f, 0.54f, -1.70f, 1.29f)
                horizontalLineToRelative(0.87f)
                curveToRelative(0.06f, -0.33f, 0.34f, -0.55f, 0.79f, -0.55f)
                curveToRelative(0.46f, 0.0f, 0.75f, 0.24f, 0.75f, 0.66f)
                verticalLineToRelative(0.29f)
                lineToRelative(-1.06f, 0.06f)
                curveToRelative(-0.98f, 0.06f, -1.52f, 0.49f, -1.52f, 1.20f)
                curveToRelative(0.0f, 0.72f, 0.56f, 1.21f, 1.34f, 1.21f)
                close()
                moveTo(13.84f, 12.15f)
                curveToRelative(-0.07f, -0.84f, -0.72f, -1.51f, -1.78f, -1.51f)
                curveToRelative(-1.16f, 0.0f, -1.92f, 0.81f, -1.92f, 2.09f)
                curveToRelative(0.0f, 1.3f, 0.76f, 2.08f, 1.93f, 2.08f)
                curveToRelative(1.01f, 0.0f, 1.70f, -0.59f, 1.77f, -1.49f)
                horizontalLineToRelative(-0.89f)
                curveToRelative(-0.09f, 0.45f, -0.40f, 0.73f, -0.87f, 0.73f)
                curveToRelative(-0.60f, 0.0f, -0.98f, -0.48f, -0.98f, -1.32f)
                curveToRelative(0.0f, -0.82f, 0.38f, -1.32f, 0.98f, -1.32f)
                curveToRelative(0.50f, 0.0f, 0.8f, 0.32f, 0.88f, 0.75f)
                horizontalLineToRelative(0.89f)
                close()
                moveTo(16.75f, 9.18f)
                curveToRelative(-1.59f, 0.0f, -2.59f, 1.09f, -2.59f, 2.82f)
                curveToRelative(0.0f, 1.74f, 1.00f, 2.82f, 2.59f, 2.82f)
                curveToRelative(1.59f, 0.0f, 2.58f, -1.08f, 2.58f, -2.82f)
                curveToRelative(0.0f, -1.74f, -1.00f, -2.82f, -2.59f, -2.82f)
                close()
                moveTo(16.75f, 10.01f)
                curveToRelative(0.97f, 0.0f, 1.59f, 0.77f, 1.59f, 1.99f)
                curveToRelative(0.0f, 1.21f, -0.62f, 1.98f, -1.59f, 1.98f)
                curveToRelative(-0.98f, 0.0f, -1.59f, -0.77f, -1.59f, -1.98f)
                curveToRelative(0.0f, -1.22f, 0.62f, -1.99f, 1.59f, -1.99f)
                close()
                moveTo(19.73f, 13.19f)
                curveToRelative(0.04f, 1.01f, 0.87f, 1.63f, 2.12f, 1.63f)
                curveToRelative(1.32f, 0.0f, 2.15f, -0.65f, 2.15f, -1.69f)
                curveToRelative(0.0f, -0.81f, -0.47f, -1.27f, -1.58f, -1.52f)
                lineToRelative(-0.63f, -0.14f)
                curveToRelative(-0.67f, -0.16f, -0.95f, -0.37f, -0.95f, -0.73f)
                curveToRelative(0.0f, -0.45f, 0.42f, -0.76f, 1.03f, -0.76f)
                curveToRelative(0.62f, 0.0f, 1.05f, 0.31f, 1.10f, 0.82f)
                horizontalLineToRelative(0.93f)
                curveToRelative(-0.02f, -0.96f, -0.82f, -1.61f, -2.02f, -1.61f)
                curveToRelative(-1.19f, 0.0f, -2.03f, 0.65f, -2.03f, 1.62f)
                curveToRelative(0.0f, 0.78f, 0.48f, 1.26f, 1.48f, 1.49f)
                lineToRelative(0.71f, 0.17f)
                curveToRelative(0.69f, 0.16f, 0.97f, 0.39f, 0.97f, 0.78f)
                curveToRelative(0.0f, 0.45f, -0.46f, 0.78f, -1.12f, 0.78f)
                curveToRelative(-0.67f, 0.0f, -1.17f, -0.33f, -1.23f, -0.83f)
                horizontalLineToRelative(-0.95f)
                close()
            }
        }
        .build()
        return _macosSimpleIcons!!
    }

private var _macosSimpleIcons: ImageVector? = null
